import { useContext } from "react"
import BodyClassName from "react-body-classname"

import { ApplicationContext } from 'context'

import Loading from 'components/Loading'
import AlertModal from 'components/AlertModal'
import ConfirmModal from 'components/ConfirmModal'

import styles from "./styles.module.scss"

const OnBoardingContainer = ({ children }) => {
  const { contextAlert, contextConfirm, contextLoading, contextError, contextAgency } = useContext(ApplicationContext)
  const [confirm, setConfirm] = contextConfirm
  const [alert, setAlert] = contextAlert
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [agency, setAgency] = contextAgency // eslint-disable-line
  const [error, setError] = contextError // eslint-disable-line

  // useEffect(() => {
  //   window.Intercom("boot", {
  //     api_base: "https://api-iam.intercom.io",
  //     app_id: "fwcutcau",
  //     externalId: props.agency?.employee_id,
  //     name: props.agency?.employee_name, // Full name
  //     email: props.agency?.employee.email, // Email address
  //     created_at: "<%= current_user.created_at.to_i %>", // Signup date as a Unix timestamp
  //     type: "AGENCY",
  //     agency_id: props.agency?.id,
  //     agency: props.agency?.companyName,
  //     user_id: props.agency?.employee_id,
  //     user_hash: props.agency?.intercomHmac
  //   })
  // }, [props.agency])

  // Alert Stuff

  const _onAlertClose = () => {
    setAlert({ display: false, title: null, text: null })
  }

  const _confirmBack = () => {
    setConfirm({ type: null, name: null, description: null, meta: null, callback: null })
  }

  const _confirmAction = () => {
    const data = { ...confirm }
    delete data.callback
    confirm.callback(data)
    setConfirm({ type: null, name: null, description: null, meta: null, callback: null })
  }

  return (
    <BodyClassName className={styles.layout__onboarding}>
      <>
        <div className={styles.onboardingContainer}>
          {error && (
            <div className={styles.error__container}>
              <div className={styles.error}>
                <div className={styles.error__left}>
                  <p>{error}</p>
                </div>
                <div className={styles.error__right}>
                  <button onClick={() => setError(null)}><i className="fa-solid fa-xmark"></i></button>
                </div>
              </div>
            </div>
          )}
          <header className={styles.onboardingContainer__header}>
            <h1>
              &nbsp;
            </h1>
            <nav>
              <ul>
                <li><a href="/logout">Logout</a></li>
              </ul>
            </nav>
          </header>
          <div className={styles.main}>
            {children}
          </div>
          <AlertModal title={alert.title} text={alert.text} isOn={alert.display} onClose={_onAlertClose} />
          {confirm.type && (
            <ConfirmModal 
              title={confirm.title}
              text={confirm.description}
              meta={confirm.meta}
              onConfirm={_confirmAction}
              onCancel={_confirmBack}
            />
          )}
          {isLoading && <Loading />}
        </div>
        <div id="visualForm"></div>
      </>
    </BodyClassName>
  )
}

export default OnBoardingContainer
